import React from 'react';

import { PascalGodOfAtlantisGameId, PascalFortuneMasterGoatGameId, PascalFortunePotsGameId } from '../../../../constants';
import { env } from '../../../../environment';

interface TournamentOpenerProps {
  gameId: number;
  onClick: () => void;
}

export const TournamentOpener: React.FC<TournamentOpenerProps> = ({ gameId, onClick }) => {

  const isAtlantisGame = gameId === PascalGodOfAtlantisGameId;
  const isFortuneMasterGoatGame = gameId === PascalFortuneMasterGoatGameId;
  const isFortunePotsGame = gameId === PascalFortunePotsGameId;

  return (
    <img
      alt="Tournament"
      onClick={onClick}
      src={`${env.filesUrl}/Icons/Tournament.png`}
      className={`tournament-opener ${isAtlantisGame ? 'atlantis' : isFortuneMasterGoatGame ? 'fortune-master-goat' : isFortunePotsGame ? 'fortune-pots' : ''}`}
    />
  );
};
